module.exports = __webpack_public_path__ + "img/group-6.77830edc.svg";